import { html, rune, View } from 'rune-ts';
import klass from './AdSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { doIf } from '../../../../../shared/util';
import { getResizedUrl } from '../../../../../shared/util/image';

interface AdCardProps {
  page: number;
}

export class AdCard extends View<AdCardProps> {
  override template({ page }: AdCardProps) {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      ad_title: html.preventEscape(ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}ad_title_${page}`)),
      ad_description: html.preventEscape(ET(`mps2::landing::plus::ad_description_${page}`)),
      ad_guide: page === 1 ? html.preventEscape(ET(`mps2::landing::plus::ad_guide_${page}`)) : '',
    };

    return html`
      <div class="${klass.ad_card}">
        <div class="${klass.content}">
          <div class="${klass.title_wrapper}">
            <div
              class="${klass.sub_title} ${typoPcMo({
                is_mobile,
                pc: '16_regular',
                mo: '14_regular',
              })}"
            >
              MarppleShop Plus #${page}
            </div>
            <div
              class="${klass.title} ${typoPcMo({
                is_mobile,
                pc: '48_bold',
                mo: '28_bold',
              })}"
            >
              ${texts.ad_title}
            </div>
            <div
              class="${klass.description} ${typoPcMo({
                is_mobile,
                pc: '20_medium',
                mo: '14_medium',
              })}"
            >
              ${texts.ad_description}
            </div>
            ${doIf(
              () => html`
                <div
                  class="${klass.guide} ${typoPcMo({
                    is_mobile,
                    pc: '14_medium',
                    mo: '12_medium',
                  })}"
                >
                  ${texts.ad_guide}
                </div>
              `,
              !!texts.ad_guide,
            )}
          </div>
        </div>

        <img
          class="${klass.image}"
          src="${getResizedUrl({
            url: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section6/ad-${page}.png`,
            width: 1920 * 2,
            format: 'webp',
            quality: 85,
          })}"
          alt="MarppleShop plus #${page} ad image"
        />
      </div>
    `;
  }
}
